import React, { useState, useEffect } from 'react';
import DataModal from './DataModal';

const MusicDataPanel = ({ selectedRegion, timeFrame, filterGenre, sortBy, isMobile = false }) => {
  const [musicData, setMusicData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalType, setModalType] = useState(null);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  // Fetch music data
  const fetchMusicData = async () => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/api/area-activity/music?region_id=${selectedRegion.id}&timeframe=${timeFrame}`
      );
      const data = await response.json();
      setMusicData(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching music data:', error);
      setLoading(false);
    }
  };

  // Initial fetch and polling every 30 seconds
  useEffect(() => {
    fetchMusicData();
    const interval = setInterval(fetchMusicData, 30000);
    return () => clearInterval(interval);
  }, [selectedRegion.id, timeFrame]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px',
        color: '#94a3b8'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      {/* Modals */}
      {modalType === 'genres' && (
        <DataModal
          title="TOP GENRES"
          icon="🎵"
          data={musicData?.top_genres}
          onClose={() => setModalType(null)}
          accentColor="#00FFFF"
          renderItem={(genre, idx) => (
            <div key={idx} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px',
              background: 'rgba(0, 255, 255, 0.05)',
              borderRadius: '8px',
              border: '1px solid rgba(0, 255, 255, 0.2)'
            }}>
              <div>
                <div style={{ fontSize: '15px', fontWeight: '600', color: '#00FFFF' }}>
                  {genre.genre}
                </div>
                <div style={{ fontSize: '13px', color: '#94a3b8', marginTop: '2px' }}>
                  {genre.plays.toLocaleString()} plays
                </div>
              </div>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: genre.change >= 0 ? '#22c55e' : '#ef4444'
              }}>
                {genre.change >= 0 ? '+' : ''}{genre.change}%
              </div>
            </div>
          )}
        />
      )}

      {modalType === 'tracks' && (
        <DataModal
          title="TRENDING TRACKS"
          icon="🔥"
          data={musicData?.trending_tracks}
          onClose={() => setModalType(null)}
          accentColor="#00FFFF"
          renderItem={(track, idx) => (
            <div key={idx} style={{
              padding: '14px',
              background: 'rgba(0, 255, 255, 0.03)',
              borderRadius: '8px',
              borderLeft: '3px solid rgba(0, 255, 255, 0.5)'
            }}>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#00FFFF',
                marginBottom: '6px'
              }}>
                #{track.rank} {track.title}
              </div>
              <div style={{ fontSize: '13px', color: '#94a3b8' }}>
                {track.artist} • {track.genre}
              </div>
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                {track.plays.toLocaleString()} plays
              </div>
            </div>
          )}
        />
      )}

      {/* Live Listening Stats Panel - MOVED TO TOP */}
      <div style={{
        background: 'rgba(255, 0, 255, 0.05)',
        border: '2px solid rgba(255, 0, 255, 0.3)',
        borderRadius: '12px',
        padding: '15px',
        boxShadow: '0 0 15px rgba(255, 0, 255, 0.2)',
        flexShrink: 0
      }}>
        <div style={{
          fontSize: '14px',
          fontWeight: '700',
          color: '#FF00FF',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span>{timeFrame === 'Live' ? '🎧' : '📊'}</span>
          <span>{timeFrame === 'Live' ? 'LIVE LISTENING' : 'TOP TRACKS'}</span>
        </div>
        {timeFrame === 'Live' ? (
          // Live Listening Stats
          musicData?.top_genres ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px',
                background: 'rgba(255, 0, 255, 0.05)',
                borderRadius: '6px'
              }}>
                <span style={{ fontSize: '11px', color: '#94a3b8' }}>Active Listeners</span>
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#FF00FF' }}>
                  {Math.floor(Math.random() * 1000 + 500).toLocaleString()}
                </span>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px',
                background: 'rgba(255, 0, 255, 0.05)',
                borderRadius: '6px'
              }}>
                <span style={{ fontSize: '11px', color: '#94a3b8' }}>Avg Session</span>
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#FF00FF' }}>
                  {Math.floor(Math.random() * 60 + 30)} mins
                </span>
              </div>
            </div>
          ) : (
            <div style={{ fontSize: '12px', color: '#94a3b8', textAlign: 'center', padding: '10px' }}>
              Loading...
            </div>
          )
        ) : (
          // Top Tracks for historical timeframes
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {musicData?.trending_tracks?.slice(0, 2).map((track, idx) => (
              <div key={idx} style={{
                padding: '8px',
                background: 'rgba(255, 0, 255, 0.03)',
                borderRadius: '6px',
                borderLeft: '3px solid rgba(255, 0, 255, 0.5)'
              }}>
                <div style={{
                  fontSize: '11px',
                  fontWeight: '600',
                  color: '#FF00FF',
                  marginBottom: '3px'
                }}>
                  #{idx + 1} {track.title}
                </div>
                <div style={{ fontSize: '10px', color: '#94a3b8' }}>
                  {track.artist} • {track.plays.toLocaleString()} plays
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Trending Tracks Panel - SPOT 2 */}
      <div style={{
        background: 'rgba(255, 0, 255, 0.05)',
        border: '2px solid rgba(255, 0, 255, 0.3)',
        borderRadius: '12px',
        padding: '15px',
        boxShadow: '0 0 15px rgba(255, 0, 255, 0.2)',
        flexShrink: 0
      }}>
        <div style={{
          fontSize: '14px',
          fontWeight: '700',
          color: '#FF00FF',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>🔥</span>
            <span>{timeFrame === 'Live' ? 'TRENDING NOW' : 'TRENDING'}</span>
          </div>
          <button
            onClick={() => setModalType('tracks')}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#FF00FF',
              fontSize: '11px',
              cursor: 'pointer',
              textDecoration: 'underline',
              padding: '0'
            }}
          >
            View All
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {musicData?.trending_tracks?.slice(0, 2).map((track, idx) => (
            <div key={idx} style={{
              padding: '8px',
              background: 'rgba(255, 0, 255, 0.03)',
              borderRadius: '6px',
              borderLeft: '3px solid rgba(255, 0, 255, 0.5)'
            }}>
              <div style={{
                fontSize: '11px',
                fontWeight: '600',
                color: '#FF00FF',
                marginBottom: '3px'
              }}>
                #{track.rank} {track.title}
              </div>
              <div style={{ fontSize: '10px', color: '#94a3b8' }}>
                {track.artist}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Top Genres Panel - SPOT 3 */}
      <div style={{
        background: 'rgba(255, 0, 255, 0.05)',
        border: '2px solid rgba(255, 0, 255, 0.3)',
        borderRadius: '12px',
        padding: '15px',
        boxShadow: '0 0 15px rgba(255, 0, 255, 0.2)',
        flexShrink: 0
      }}>
        <div style={{
          fontSize: '14px',
          fontWeight: '700',
          color: '#FF00FF',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>🎵</span>
            <span>TOP GENRES</span>
          </div>
          <button
            onClick={() => setModalType('genres')}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#FF00FF',
              fontSize: '11px',
              cursor: 'pointer',
              textDecoration: 'underline',
              padding: '0'
            }}
          >
            View All
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {musicData?.top_genres?.slice(0, 2).map((genre, idx) => (
            <div key={idx} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '6px',
              background: 'rgba(255, 0, 255, 0.05)',
              borderRadius: '6px'
            }}>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '600', color: '#FF00FF' }}>
                  {genre.genre}
                </div>
                <div style={{ fontSize: '10px', color: '#94a3b8' }}>
                  {genre.plays.toLocaleString()} plays
                </div>
              </div>
              <div style={{
                fontSize: '11px',
                fontWeight: '600',
                color: genre.change >= 0 ? '#22c55e' : '#ef4444'
              }}>
                {genre.change >= 0 ? '+' : ''}{genre.change}%
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MusicDataPanel;
